import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Nftecosystem() {
  return (
    <section className="nft_ecosystem p-100" style={{ background: "#F8F8FB" }}>
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Our Core Android App Development Competencies</h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Kotlin & Java Proficiency</h5>
                  </div>
                  <p>
                    Our developers are experts in Kotlin and Java, the primary
                    languages for Android development. This expertise ensures
                    efficient and maintainable code, optimizing performance and
                    App Store presence.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Version Control Expertise</h5>
                  </div>
                  <p>
                    Our team excels in using version control tools like Git and
                    SVN. These tools manage code changes, facilitate
                    collaboration, and maintain project integrity. Advanced
                    version control practices ensure smooth scaling and precise
                    control at every development stage.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Database Management</h5>
                  </div>
                  <p>
                    We have extensive knowledge of database systems, including
                    SQLite, Firebase Realtime Database, and Room. This allows us
                    to develop cohesive Android apps that handle large datasets
                    and scale efficiently as your business grows.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Advanced Android Frameworks</h5>
                  </div>
                  <p>
                    Our developers are skilled in using the latest Android
                    frameworks and libraries such as Jetpack, Dagger, and
                    RxJava. Combined with expertise in Android Studio, we
                    deliver high-performance applications leveraging Android's
                    full capabilities.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Exceptional UI/UX Design</h5>
                  </div>
                  <p>
                    Understanding the importance of seamless user experience,
                    our developers excel in UI/UX principles. This expertise
                    allows them to collaborate with designers to create
                    intuitive, visually appealing, and user-friendly Android
                    applications that enhance user engagement.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="nft_ecosystem_box">
                  <div className="nft_eco_head">
                    <h5>Third-Party API Integration</h5>
                  </div>
                  <p>
                    We specialize in integrating RESTful and GraphQL APIs,
                    enhancing Android apps with real-time data exchange and
                    scalable features. This expertise ensures seamless
                    integration and robust app functionality.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Nftecosystem;
